import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { OperationDateLink } from './treatment-date.model';

@Component({
  selector: 'stx-treatment-date',
  templateUrl: './treatment-date.component.html',
  styleUrls: ['./treatment-date.component.scss'],
  imports: [RouterLink, MatIcon]
})
export class TreatmentDateComponent {
  @Input() direction: 'row' | 'column' = 'row';
  @Input() createDateLink: OperationDateLink;
  @Input() createDate: string;
  @Input() submitDate: string;
  @Input() operationDateLink: OperationDateLink;
  @Input() operationDate: string;
}
